import script from "./video.vue?vue&type=script&setup=true&lang=js"
export * from "./video.vue?vue&type=script&setup=true&lang=js"

import "./video.vue?vue&type=style&index=0&id=b67b4fca&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b67b4fca"]])

export default __exports__